import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';

window.Alpine = Alpine;

Alpine.plugin(collapse);

Alpine.data('specsVideo', () => ({
    showVideo: false,
    videoUrl: null,
    playVideo(url) {
        if (!url) {
            return;
        }
        this.videoUrl = url;
        this.showVideo = true;
        this.$nextTick(() => {
            const videoEl = this.$refs.detailVideo;
            if (videoEl) {
                videoEl.load();
                if (typeof videoEl.play === 'function') {
                    videoEl.play();
                }
            }
        });
    },
    closeVideo() {
        const videoEl = this.$refs.detailVideo;
        if (videoEl) {
            videoEl.pause();
            videoEl.currentTime = 0;
        }
        this.showVideo = false;
    },
}));

Alpine.data('sitePopup', (isActive = false) => ({
    popUpMain: !!isActive,
    init() {
        if (!this.popUpMain) {
            return;
        }
        if (typeof window === 'undefined' || !('sessionStorage' in window)) {
            return;
        }
        if (window.sessionStorage.getItem('meditechPopUpSeen') === '1') {
            this.popUpMain = false;
        }
    },
    closePopUp() {
        this.popUpMain = false;
        if (typeof window !== 'undefined' && 'sessionStorage' in window) {
            window.sessionStorage.setItem('meditechPopUpSeen', '1');
        }
    },
}));

Alpine.start();
